import React from "react";
import styles from '../cookies/CookiesExternal.module.css';
import FooterExternal from "../../footer/FooterExternal";
import PrivacyPolicyContent from "../../privacyPolicy/PrivacyPolicyContent";
import { useNavigate } from "react-router-dom";
import PrivacyPolicyContentJotform from "../../privacyPolicy/PrivacyPolicyContentJotform";

export default function PrivacyPolicyExternalJotform(){

    const navigate = useNavigate();

    const navigateToLogin = () => {
        navigate('/');
    }

    return (
        <>
            <main className={styles.background}>
                <div className={styles.overlay}></div>
                <div className={styles.paneContainer}>
                    <div className={styles.pane}>
                        <div className={styles.paneLower}>
                            <h3>Privacy Policy - Jotform</h3>
                            <br/>
                            <PrivacyPolicyContentJotform/>
                            <button onClick={navigateToLogin} className={styles.returnBtn}>Go to Login</button>
                        </div>
                    </div>
                </div>
            </main>
            <FooterExternal />
        </>
    )
}